module.exports = __webpack_public_path__ + "images/default_avatars/cloud-cc186c7f465586155d6edc3d22549b3c.jpg";